export default {
    // 中
    zhCN: {
        fill_in_at_least_one_query_condition: '至少填写一个查询条件',
        organization_name: '组织名称',
        query_time: '查询时间',
        organization_code: '组织CODE',
        country: '国家',
        number_of_cases: '案例总数',
        average_replied_cases: '工程师单据平均答复单数',
        total_cases: '工程师案例总数',
        engineer_name: '工程师',
        waiting_for_reply_cases: '未答复案例数量',
        percentage_waiting_for_reply_cases: '未答复案例百分比',
        replied_cases: '已答复案例数量',
        percentage_replied_cases: '已答复数量百分比',
        closed_cases: '已结案案例数量',
        percentage_closed_cases: '已结案数量百分比',
    },
    // 英
    enUS: {
        fill_in_at_least_one_query_condition: 'Fill in at least one query condition',
        organization_name: 'Organization name',
        query_time: 'Query time',
        organization_code: 'Organization code',
        country: 'Country',
        number_of_cases: 'Number of cases',
        average_replied_cases: 'Average replied cases',
        total_cases: 'Total cases',
        engineer_name: 'Engineer name',
        waiting_for_reply_cases: 'Waiting for reply cases',
        percentage_waiting_for_reply_cases: 'Waiting for reply cases (%)',
        replied_cases: 'Replied cases',
        percentage_replied_cases: 'Replied cases (%)',
        closed_cases: 'Closed cases',
        percentage_closed_cases: 'Closed cases (%)',
    },
    // 德
    deDE: {
        fill_in_at_least_one_query_condition: 'Füllen Sie mindestens eine Abfragebedingung aus',
        organization_name: 'Organisationsname',
        query_time: 'Abfragezeit',
        organization_code: 'Organisationscode',
        country: 'Land',
        number_of_cases: 'Gesamtzahl der Fälle',
        average_replied_cases: 'Durchschnittlich beantwortete Fälle',
        total_cases: 'Gesamtzahl der Fälle',
        engineer_name: 'Name des Ingenieurs',
        waiting_for_reply_cases: 'Fälle, die auf Antwort warten',
        percentage_waiting_for_reply_cases: 'Fälle, die auf Antwort warten (%)',
        replied_cases: 'Beantwortete Fälle',
        percentage_replied_cases: 'Beantwortete Fälle (%)',
        closed_cases: 'Geschlossene Fälle',
        percentage_closed_cases: 'Geschlossene Fälle (%)',
    },
    // 法
    frFR: {
        fill_in_at_least_one_query_condition: 'Remplissez au moins une condition de demande',
        organization_name: 'Nom organisation',
        query_time: 'Temps de requête',
        organization_code: 'Code organisation',
        country: 'Pays',
        number_of_cases: 'Nombre de cas',
        average_replied_cases: 'Moyenne des cas répondus',
        total_cases: 'Total cas',
        engineer_name: 'Nom de l\'ingénieur',
        waiting_for_reply_cases: 'Cas en attente de retour',
        percentage_waiting_for_reply_cases: 'Cas en attente de retour (%)',
        replied_cases: 'Cas répondus',
        percentage_replied_cases: 'Cas répondus (%)',
        closed_cases: 'Cas clôturés',
        percentage_closed_cases: 'Cas clôturés (%)',
    },
    // 意大利
    itIT: {
        fill_in_at_least_one_query_condition: 'Compilare almeno una condizione di query',
        organization_name: 'Nome Organizzazione',
        query_time: 'Tempo di Query',
        organization_code: 'Codice Organizzazione',
        country: 'Paese',
        number_of_cases: 'Numero totale di casi',
        average_replied_cases: 'Numero Medio di Casi Risposti per Dipendente',
        total_cases: 'Numero Totale di Casi dei Dipendenti',
        engineer_name: 'Nome Dipendente',
        waiting_for_reply_cases: 'Numero di Casi in Attesa di Risposta',
        percentage_waiting_for_reply_cases: 'Percentuale di Casi in Attesa di Risposta',
        replied_cases: 'Numero di Casi ai Quali è Stata Fornita una Risposta',
        percentage_replied_cases: 'Percentuale di Casi ai Quali è Stata Fornita una Risposta',
        closed_cases: 'Numero di Casi Chiusi',
        percentage_closed_cases: 'Percentuale di Casi Chiusi',
    },
    // 荷兰
    nlNL: {
        fill_in_at_least_one_query_condition: 'Vul ten minste één query voorwaarde in',
        organization_name: 'Organisatie naam',
        query_time: 'Query time',
        organization_code: 'Organisatie code',
        country: 'Land',
        number_of_cases: 'Totaal aantal gevallen',
        average_replied_cases: 'Gemiddelde beantwoorde gevallen',
        total_cases: 'Totaal aantal gevallen',
        engineer_name: 'Ingenieursnaam',
        waiting_for_reply_cases: 'Wachten op antwoord gevallen',
        percentage_waiting_for_reply_cases: 'Wachten op antwoord gevallen (%)',
        replied_cases: 'Beantwoorde gevallen',
        percentage_replied_cases: 'Beantwoorde gevallen (%)',
        closed_cases: 'Gesloten gevallen',
        percentage_closed_cases: 'Gesloten gevallen(%)',
    },
    // 越南
    viVN: {
        fill_in_at_least_one_query_condition: 'Ít nhất điền một điều kiện tìm kiếm',
        organization_name: 'Tên tổ chức',
        query_time: 'Thời gian truy vấn',
        organization_code: 'Mã tổ chức',
        country: 'Quốc gia',
        number_of_cases: 'Số lượng trường hợp',
        average_replied_cases: 'Trung bình các trường hợp đã trả lời',
        total_cases: 'Tổng số trường hợp',
        engineer_name: 'Tên kỹ sư',
        waiting_for_reply_cases: 'Các trường hợp đang chờ trả lời',
        percentage_waiting_for_reply_cases: 'Tỉ lệ các trường hợp đang chờ trả lời (%)',
        replied_cases: 'Các trường hợp đã trả lời',
        percentage_replied_cases: 'Tỉ lệ các trường hợp đã trả lời (%)',
        closed_cases: 'Các trường hợp đã đóng',
        percentage_closed_cases: 'Tỉ lệ các trường hợp đã đóng (%)',
    },
    // 西班牙
    esES: {
        fill_in_at_least_one_query_condition: 'Al menos complete un criterio de búsqueda',
        organization_name: 'Nombre de la organización',
        query_time: 'Tiempo de consulta',
        organization_code: 'Código de la organización',
        country: 'País',
        number_of_cases: 'Número total de casos',
        average_replied_cases: 'Promedio de respuestas por ingeniero',
        total_cases: 'Número total de casos por ingeniero',
        engineer_name: 'Ingeniero',
        waiting_for_reply_cases: 'Cantidad de casos no respondidos',
        percentage_waiting_for_reply_cases: 'Porcentaje de casos no respondidos',
        replied_cases: 'Cantidad de casos respondidos',
        percentage_replied_cases: 'Porcentaje de casos respondidos',
        closed_cases: 'Cantidad de casos cerrados',
        percentage_closed_cases: 'Porcentaje de casos cerrados',
    },
    // 葡萄牙
    ptBR: {
        fill_in_at_least_one_query_condition: 'Preencha pelo menos uma condição de consulta',
        organization_name: 'Nome da organização',
        query_time: 'Tempo de consulta',
        organization_code: 'Código da organização',
        country: 'País',
        number_of_cases: 'Total de casos',
        average_replied_cases: 'Número médio de respostas por engenheiro',
        total_cases: 'Total de casos por engenheiro',
        engineer_name: 'Engenheiro',
        waiting_for_reply_cases: 'Número de casos aguardando resposta',
        percentage_waiting_for_reply_cases: 'Porcentagem de casos aguardando resposta',
        replied_cases: 'Número de casos respondidos',
        percentage_replied_cases: 'Porcentagem de casos respondidos',
        closed_cases: 'Número de casos encerrados',
        percentage_closed_cases: 'Porcentagem de casos encerrados',
    },
    // 波兰
    plPL: {
        fill_in_at_least_one_query_condition: 'Wypełnij co najmniej jeden warunek zapytania',
        organization_name: 'Nazwa organizacji',
        query_time: 'Data zapytania',
        organization_code: 'Kod organizacji',
        country: 'Kraj',
        number_of_cases: 'Łączna liczba spraw',
        average_replied_cases: 'Średnia liczba odpowiedzi',
        total_cases: 'Łączna liczba spraw',
        engineer_name: 'Nazwa inżyniera',
        waiting_for_reply_cases: 'Liczba spraw oczekujących na odpowiedź',
        percentage_waiting_for_reply_cases: 'Sprawy oczekujące na odpowiedź (%)',
        replied_cases: 'Udzielone odpowiedzi',
        percentage_replied_cases: 'Udzielone odpowiedzi (%)',
        closed_cases: 'Sprawy zamknięte',
        percentage_closed_cases: 'Sprawy zamknięte (%)',
    },
    // 土耳其
    trTR: {
        fill_in_at_least_one_query_condition: 'En azından bir soru durumunu doldur',
        organization_name: 'Organizasyon adı',
        query_time: 'Sorgulama zamanı',
        organization_code: 'Organizasyon CODE',
        country: 'Ülke',
        number_of_cases: 'Toplam vakalar',
        average_replied_cases: 'Ortalama cevaplanan  dosyalar',
        total_cases: 'Toplam  dosyalar',
        engineer_name: 'Mühendis adı',
        waiting_for_reply_cases: 'Dosya cevaplanmayı bekliyor',
        percentage_waiting_for_reply_cases: 'Cevap  bekleyen dosyalar (%)',
        replied_cases: 'Cevaplanmış  dosyalar',
        percentage_replied_cases: 'Cevaplanmış  dosyalar (%)',
        closed_cases: 'Kapatılmış  dosyalar',
        percentage_closed_cases: 'Kapatılmış  dosyalar (%)',
    },
    // 捷克语
    csCZ: {
        fill_in_at_least_one_query_condition: 'Vyplňte alespoň jednu podmínku dotazu',
        organization_name: 'Název společnosti',
        query_time: 'Čas dotazu',
        organization_code: 'Kód společnosti',
        country: 'Země',
        number_of_cases: 'Počet případů',
        average_replied_cases: 'Průměrný počet odpovědí',
        total_cases: 'Celkový počet případů',
        engineer_name: 'Jméno technika',
        waiting_for_reply_cases: 'Čeká na odpověď',
        percentage_waiting_for_reply_cases: 'Čeká na odpověď (%)',
        replied_cases: 'Odpovězené případy',
        percentage_replied_cases: 'Odpovězené případy (%)',
        closed_cases: 'Uzavřené případy',
        percentage_closed_cases: 'Uzavřené případy (%)',
    },
    // 匈牙利语
    huHU: {
        fill_in_at_least_one_query_condition: 'Töltsön ki legalább egy lekérdezési feltételt',
        organization_name: 'Szervezet neve',
        query_time: 'Lekérdezési idő',
        organization_code: 'Szervezet kódja',
        country: 'Ország',
        number_of_cases: 'Esetek száma',
        average_replied_cases: 'Átlagosan megválaszolt esetek',
        total_cases: 'Összes eset',
        engineer_name: 'Szerelő neve',
        waiting_for_reply_cases: 'Reakcióra váró esetek',
        percentage_waiting_for_reply_cases: 'Reakcióra váró esetek (%)',
        replied_cases: 'Megválaszolt esetek',
        percentage_replied_cases: 'Megválaszolt esetek (%)',
        closed_cases: 'Lezárt esetek',
        percentage_closed_cases: 'Lezárt esetek (%)',
    },
    // 俄罗斯语
    ruRU: {
        fill_in_at_least_one_query_condition: 'Заполните хотя бы одно условие запроса',
        organization_name: 'Название организации',
        query_time: 'Время запроса',
        organization_code: 'Код организации',
        country: 'Страна',
        number_of_cases: 'Общее количество случаев',
        average_replied_cases: 'Среднее количество ответов на заявки инженеров',
        total_cases: 'Общее количество случаев инженеров',
        engineer_name: 'Имя инженера',
        waiting_for_reply_cases: 'Количество ожидающих ответа случаев',
        percentage_waiting_for_reply_cases: 'Процент ожидающих ответа случаев',
        replied_cases: 'Количество ответов на случаи',
        percentage_replied_cases: 'Процент ответов на случаи',
        closed_cases: 'Количество закрытых случаев',
        percentage_closed_cases: 'Процент закрытых случаев',
    },
    // 沙特阿拉伯
    arSA: {
        fill_in_at_least_one_query_condition: 'يرجى إدخال شرط بحث واحد على الأقل',
        organization_name: 'اسم المنظمة',
        query_time: 'وقت الاستعلام',
        organization_code: 'رمز المنظمة',
        country: 'الدولة',
        number_of_cases: 'إجمالي عدد الحالات',
        average_replied_cases: 'متوسط عدد الردود لكل مهندس',
        total_cases: 'إجمالي حالات المهندس',
        engineer_name: 'المهندس',
        waiting_for_reply_cases: 'عدد الحالات غير المجابة',
        percentage_waiting_for_reply_cases: 'نسبة الحالات غير المجابة',
        replied_cases: 'عدد الحالات المجابة',
        percentage_replied_cases: 'نسبة الحالات المجابة',
        closed_cases: 'عدد الحالات المغلقة',
        percentage_closed_cases: 'نسبة الحالات المغلقة',
    },
    // 保加利亚
    bgBG: {
        fill_in_at_least_one_query_condition: 'Моля, попълнете поне едно условие за търсене',
        organization_name: 'Име на организацията',
        query_time: 'Време на заявката',
        organization_code: 'Код на организацията',
        country: 'Държава',
        number_of_cases: 'Общ брой случаи',
        average_replied_cases: 'Среден брой отговорени документи на инженер',
        total_cases: 'Общ брой случаи на инженера',
        engineer_name: 'Инженер',
        waiting_for_reply_cases: 'Брой непотвърдени случаи',
        percentage_waiting_for_reply_cases: 'Процент непотвърдени случаи',
        replied_cases: 'Брой потвърдени случаи',
        percentage_replied_cases: 'Процент потвърдени случаи',
        closed_cases: 'Брой приключени случая',
        percentage_closed_cases: 'Процент приключени случаи',
    },
    // 丹麦语
    daDK: {
        fill_in_at_least_one_query_condition: 'Angiv mindst ét søgekriterie',
        organization_name: 'Organisationsnavn',
        query_time: 'Forespørgselstidspunkt',
        organization_code: 'Organisationskode',
        country: 'Land',
        number_of_cases: 'Samlet antal sager',
        average_replied_cases: 'Gennemsnitligt antal besvarede sager pr. ingeniør',
        total_cases: 'Ingeniørens samlede antal sager',
        engineer_name: 'Ingeniør',
        waiting_for_reply_cases: 'Antal ubesvarede sager',
        percentage_waiting_for_reply_cases: 'Procentdel af ubesvarede sager',
        replied_cases: 'Antal besvarede sager',
        percentage_replied_cases: 'Procentdel af besvarede sager',
        closed_cases: 'Antal lukkede sager',
        percentage_closed_cases: 'Procentdel af lukkede sager',
    },
    // 芬兰语
    fiFI: {
        fill_in_at_least_one_query_condition: 'Anna vähintään yksi hakuehto',
        organization_name: 'Organisaation nimi',
        query_time: 'Hakuaika',
        organization_code: 'Organisaatiokoodi',
        country: 'Maa',
        number_of_cases: 'Tapauksien kokonaismäärä',
        average_replied_cases: 'Insinöörin keskimääräinen vastattujen lomakkeiden määrä',
        total_cases: 'Insinöörin tapausten kokonaismäärä',
        engineer_name: 'Insinööri',
        waiting_for_reply_cases: 'Vastaamattomien tapausten määrä',
        percentage_waiting_for_reply_cases: 'Vastaamattomien tapausten prosenttiosuus',
        replied_cases: 'Vastattujen tapausten määrä',
        percentage_replied_cases: 'Vastattujen tapausten prosenttiosuus',
        closed_cases: 'Suljettujen tapausten määrä',
        percentage_closed_cases: 'Suljettujen tapausten prosenttiosuus',
    },
    // 繁体中文台湾
    zhTW: {
        fill_in_at_least_one_query_condition: '至少填寫一個查詢條件',
        organization_name: '組織名稱',
        query_time: '查詢時間',
        organization_code: '組織CODE',
        country: '國家',
        number_of_cases: '案例總數',
        average_replied_cases: '工程師單據平均答覆單數',
        total_cases: '工程師案例總數',
        engineer_name: '工程師',
        waiting_for_reply_cases: '未答覆案例數量',
        percentage_waiting_for_reply_cases: '未答覆案例百分比',
        replied_cases: '已答覆案例數量',
        percentage_replied_cases: '已答覆數量百分比',
        closed_cases: '已結案案例數量',
        percentage_closed_cases: '已結案數量百分比',
    },
    // 克罗地亚
    hrHR: {
        fill_in_at_least_one_query_condition: 'Unesite barem jedan uvjet pretraživanja',
        organization_name: 'Naziv organizacije',
        query_time: 'Vrijeme upita',
        organization_code: 'Kôd organizacije',
        country: 'Država',
        number_of_cases: 'Ukupan broj slučajeva',
        average_replied_cases: 'Prosječan broj odgovorenih zahtjeva po inženjeru',
        total_cases: 'Ukupan broj slučajeva inženjera',
        engineer_name: 'Inženjer',
        waiting_for_reply_cases: 'Broj neodgovorenih slučajeva',
        percentage_waiting_for_reply_cases: 'Postotak neodgovorenih slučajeva',
        replied_cases: 'Broj odgovorenih slučajeva',
        percentage_replied_cases: 'Postotak odgovorenih slučajeva',
        closed_cases: 'Broj zatvorenih slučajeva',
        percentage_closed_cases: 'Postotak zatvorenih slučajeva',
    },
    // 拉脱维亚
    lvLV: {
        fill_in_at_least_one_query_condition:
            'Lūdzu, aizpildiet vismaz vienu meklēšanas nosacījumu',
        organization_name: 'Organizācijas nosaukums',
        query_time: 'Vaicājuma laiks',
        organization_code: 'Organizācijas kods',
        country: 'Valsts',
        number_of_cases: 'Gadījumu kopējais skaits',
        average_replied_cases: 'Vidējais atbildēto dokumentu skaits uz inženieri',
        total_cases: 'Inženiera gadījumu kopējais skaits',
        engineer_name: 'Inženieris',
        waiting_for_reply_cases: 'Neatbildēto gadījumu skaits',
        percentage_waiting_for_reply_cases: 'Neatbildēto gadījumu procents',
        replied_cases: 'Atbildēto gadījumu skaits',
        percentage_replied_cases: 'Atbildēto gadījumu procents',
        closed_cases: 'Slēgto gadījumu skaits',
        percentage_closed_cases: 'Slēgto gadījumu procents',
    },
    // 立陶宛
    ltLT: {
        fill_in_at_least_one_query_condition: 'Įveskite bent vieną paieškos sąlygą',
        organization_name: 'Organizacijos pavadinimas',
        query_time: 'Užklausos laikas',
        organization_code: 'Organizacijos kodas',
        country: 'Šalis',
        number_of_cases: 'Atvejų skaičius iš viso',
        average_replied_cases: 'Vidutinis inžinieriaus atsakytų dokumentų skaičius',
        total_cases: 'Inžinieriaus atvejų bendras skaičius',
        engineer_name: 'Inžinierius',
        waiting_for_reply_cases: 'Neatsakytų atvejų skaičius',
        percentage_waiting_for_reply_cases: 'Neatsakytų atvejų procentas',
        replied_cases: 'Atsakytų atvejų skaičius',
        percentage_replied_cases: 'Atsakytų atvejų procentas',
        closed_cases: 'Uždarytų atvejų skaičius',
        percentage_closed_cases: 'Uždarytų atvejų procentas',
    },
    // 罗马尼亚
    roRO: {
        fill_in_at_least_one_query_condition: 'Completați cel puțin o condiție de căutare',
        organization_name: 'Numele organizației',
        query_time: 'Timpul interogării',
        organization_code: 'Codul organizației',
        country: 'Țară',
        number_of_cases: 'Număr total de cazuri',
        average_replied_cases: 'Numărul mediu de răspunsuri per inginer',
        total_cases: 'Numărul total de cazuri ale inginerului',
        engineer_name: 'Inginer',
        waiting_for_reply_cases: 'Numărul de cazuri fără răspuns',
        percentage_waiting_for_reply_cases: 'Procentul cazurilor fără răspuns',
        replied_cases: 'Numărul de cazuri cu răspuns',
        percentage_replied_cases: 'Procentul cazurilor cu răspuns',
        closed_cases: 'Numărul de cazuri închise',
        percentage_closed_cases: 'Procentul cazurilor închise',
    },
    // 挪威博克马尔
    nbNO: {
        fill_in_at_least_one_query_condition: 'Fyll ut minst ett søkekriterium',
        organization_name: 'Organisasjonsnavn',
        query_time: 'Spørringstidspunkt',
        organization_code: 'Organisasjonskode',
        country: 'Land',
        number_of_cases: 'Totalt antall saker',
        average_replied_cases: 'Gjennomsnittlig antall besvarte saksdokument per ingeniør',
        total_cases: 'Ingeniørens totale antall saker',
        engineer_name: 'Ingeniør',
        waiting_for_reply_cases: 'Antall ubesvarte saker',
        percentage_waiting_for_reply_cases: 'Prosentandel ubesvarte saker',
        replied_cases: 'Antall besvarte saker',
        percentage_replied_cases: 'Prosentandel besvarte saker',
        closed_cases: 'Antall lukkede saker',
        percentage_closed_cases: 'Prosentandel lukkede saker',
    },
    // 葡萄牙语巴西
    ptBX: {
        fill_in_at_least_one_query_condition: 'Preencha pelo menos uma condição de consulta',
        organization_name: 'Nome da organização',
        query_time: 'Horário da consulta',
        organization_code: 'Código da organização',
        country: 'País',
        number_of_cases: 'Número total de casos',
        average_replied_cases: 'Média de respostas por engenheiro',
        total_cases: 'Total de casos do engenheiro',
        engineer_name: 'Engenheiro',
        waiting_for_reply_cases: 'Quantidade de casos sem resposta',
        percentage_waiting_for_reply_cases: 'Percentual de casos sem resposta',
        replied_cases: 'Quantidade de casos respondidos',
        percentage_replied_cases: 'Percentual de casos respondidos',
        closed_cases: 'Quantidade de casos encerrados',
        percentage_closed_cases: 'Percentual de casos encerrados',
    },
    // 瑞典语
    svSE: {
        fill_in_at_least_one_query_condition: 'Ange minst ett sökvillkor',
        organization_name: 'Organisationsnamn',
        query_time: 'Förfråganstidpunkt',
        organization_code: 'Organisationskod',
        country: 'Land',
        number_of_cases: 'Totalt antal fall',
        average_replied_cases: 'Genomsnittligt antal besvarade ärenden per ingenjör',
        total_cases: 'Ingenjörens totala antal ärenden',
        engineer_name: 'Ingenjör',
        waiting_for_reply_cases: 'Antal obesvarade ärenden',
        percentage_waiting_for_reply_cases: 'Andel obesvarade ärenden (%)',
        replied_cases: 'Antal besvarade ärenden',
        percentage_replied_cases: 'Andel besvarade ärenden (%)',
        closed_cases: 'Antal avslutade ärenden',
        percentage_closed_cases: 'Andel avslutade ärenden (%)',
    },
    // 斯洛伐克
    skSK: {
        fill_in_at_least_one_query_condition: 'Zadajte aspoň jednu podmienku vyhľadávania',
        organization_name: 'Názov organizácie',
        query_time: 'Čas dopytu',
        organization_code: 'Kód organizácie',
        country: 'Krajina',
        number_of_cases: 'Celkový počet prípadov',
        average_replied_cases: 'Priemerný počet odpovedaných dokladov na inžiniera',
        total_cases: 'Celkový počet prípadov inžiniera',
        engineer_name: 'Inžinier',
        waiting_for_reply_cases: 'Počet nezodpovedaných prípadov',
        percentage_waiting_for_reply_cases: 'Percento nezodpovedaných prípadov',
        replied_cases: 'Počet zodpovedaných prípadov',
        percentage_replied_cases: 'Percento zodpovedaných prípadov',
        closed_cases: 'Počet uzavretých prípadov',
        percentage_closed_cases: 'Percento uzavretých prípadov',
    },
    // 斯洛文尼亚
    slSI: {
        fill_in_at_least_one_query_condition: 'Vnesite vsaj en pogoj za poizvedbo',
        organization_name: 'Ime organizacije',
        query_time: 'Čas poizvedbe',
        organization_code: 'Koda organizacije',
        country: 'Država',
        number_of_cases: 'Skupno število primerov',
        average_replied_cases: 'Povprečno število odgovorjenih dokumentov na inženirja',
        total_cases: 'Skupno število primerov inženirja',
        engineer_name: 'Inženir',
        waiting_for_reply_cases: 'Število neodgovorjenih primerov',
        percentage_waiting_for_reply_cases: 'Odstotek neodgovorjenih primerov',
        replied_cases: 'Število odgovorjenih primerov',
        percentage_replied_cases: 'Odstotek odgovorjenih primerov',
        closed_cases: 'Število zaključenih primerov',
        percentage_closed_cases: 'Odstotek zaključenih primerov',
    },
    // 泰语
    thTH: {
        fill_in_at_least_one_query_condition: 'กรุณากรอกเงื่อนไขการค้นหาอย่างน้อยหนึ่งรายการ',
        organization_name: 'ชื่อองค์กร',
        query_time: 'เวลาการสอบถาม',
        organization_code: 'รหัสองค์กร',
        country: 'ประเทศ',
        number_of_cases: 'จำนวนกรณีทั้งหมด',
        average_replied_cases: 'จำนวนเอกสารเฉลี่ยที่วิศวกรตอบกลับ',
        total_cases: 'จำนวนกรณีทั้งหมดของวิศวกร',
        engineer_name: 'วิศวกร',
        waiting_for_reply_cases: 'จำนวนกรณีที่ยังไม่ได้ตอบกลับ',
        percentage_waiting_for_reply_cases: 'เปอร์เซ็นต์ของกรณีที่ยังไม่ได้ตอบกลับ',
        replied_cases: 'จำนวนกรณีที่ตอบกลับแล้ว',
        percentage_replied_cases: 'เปอร์เซ็นต์ของกรณีที่ตอบกลับแล้ว',
        closed_cases: 'จำนวนกรณีที่ปิดแล้ว',
        percentage_closed_cases: 'เปอร์เซ็นต์ของกรณีที่ปิดแล้ว',
    },
    // 乌克兰语
    ukUA: {
        fill_in_at_least_one_query_condition: 'Будь ласка, введіть принаймні одну умову пошуку',
        organization_name: 'Назва організації',
        query_time: 'Час запиту',
        organization_code: 'Код організації',
        country: 'Країна',
        number_of_cases: 'Загальна кількість випадків',
        average_replied_cases: 'Середня кількість відповідей інженера на документи',
        total_cases: 'Загальна кількість випадків інженера',
        engineer_name: 'Інженер',
        waiting_for_reply_cases: 'Кількість невідповідних випадків',
        percentage_waiting_for_reply_cases: 'Відсоток невідповідних випадків',
        replied_cases: 'Кількість відповідних випадків',
        percentage_replied_cases: 'Відсоток відповідних випадків',
        closed_cases: 'Кількість закритих випадків',
        percentage_closed_cases: 'Відсоток закритих випадків',
    },
    // 希腊语
    elGR: {
        fill_in_at_least_one_query_condition: 'Συμπληρώστε τουλάχιστον ένα κριτήριο αναζήτησης',
        organization_name: 'Όνομα οργανισμού',
        query_time: 'Χρόνος ερωτήματος',
        organization_code: 'Κωδικός οργανισμού',
        country: 'Χώρα',
        number_of_cases: 'Συνολικός αριθμός περιστατικών',
        average_replied_cases: 'Μέσος όρος απαντημένων εγγράφων ανά μηχανικό',
        total_cases: 'Συνολικός αριθμός περιστατικών μηχανικού',
        engineer_name: 'Μηχανικός',
        waiting_for_reply_cases: 'Αριθμός περιστατικών που δεν έχουν απαντηθεί',
        percentage_waiting_for_reply_cases: 'Ποσοστό περιστατικών που δεν έχουν απαντηθεί',
        replied_cases: 'Αριθμός περιστατικών που έχουν απαντηθεί',
        percentage_replied_cases: 'Ποσοστό απαντημένων περιστατικών',
        closed_cases: 'Αριθμός κλεισμένων περιστατικών',
        percentage_closed_cases: 'Ποσοστό κλεισμένων περιστατικών',
    },
    // 爱沙尼亚
    etEE: {
        fill_in_at_least_one_query_condition: 'Sisestage vähemalt üks otsingu tingimus',
        organization_name: 'Organisatsiooni nimi',
        query_time: 'Päringu aeg',
        organization_code: 'Organisatsiooni kood',
        country: 'Riik',
        number_of_cases: 'Juhtumite koguarv',
        average_replied_cases: 'Inseneri dokumendivastuste keskmine arv',
        total_cases: 'Inseneri juhtumite koguarv',
        engineer_name: 'Insener',
        waiting_for_reply_cases: 'Vastamata juhtumite arv',
        percentage_waiting_for_reply_cases: 'Vastamata juhtumite protsent',
        replied_cases: 'Vastatud juhtumite arv',
        percentage_replied_cases: 'Vastatud juhtumite protsent',
        closed_cases: 'Suletud juhtumite arv',
        percentage_closed_cases: 'Suletud juhtumite protsent',
    },
    // 哈萨克
    kkKZ: {
        fill_in_at_least_one_query_condition: 'Кем дегенде бір сұрау шартын енгізіңіз',
        organization_name: 'Ұйым атауы',
        query_time: 'Сұрау уақыты',
        organization_code: 'Ұйым коды',
        country: 'Ел',
        number_of_cases: 'Жағдайлардың жалпы саны',
        average_replied_cases: 'Инженердің құжаттарға орташа жауап беру саны',
        total_cases: 'Инженердің жағдайларының жалпы саны',
        engineer_name: 'Инженер',
        waiting_for_reply_cases: 'Жауап берілмеген жағдайлар саны',
        percentage_waiting_for_reply_cases: 'Жауап берілмеген жағдайлар пайызы',
        replied_cases: 'Жауап берілген жағдайлар саны',
        percentage_replied_cases: 'Жауап берілген жағдайлар пайызы',
        closed_cases: 'Жабылған жағдайлар саны',
        percentage_closed_cases: 'Жабылған жағдайлар пайызы',
    },
    // 希伯来语
    heIL: {
        fill_in_at_least_one_query_condition: 'יש למלא לפחות תנאי חיפוש אחד',
        organization_name: 'שם הארגון',
        query_time: 'זמן השאילתה',
        organization_code: 'קוד ארגון',
        country: 'מדינה',
        number_of_cases: 'סך כל המקרים',
        average_replied_cases: 'מספר ממוצע של תגובות מהנדס למסמכים',
        total_cases: 'סך כל המקרים של המהנדס',
        engineer_name: 'מהנדס',
        waiting_for_reply_cases: 'כמות מקרים ללא תגובה',
        percentage_waiting_for_reply_cases: 'אחוז מקרים ללא תגובה',
        replied_cases: 'כמות מקרים עם תגובה',
        percentage_replied_cases: 'אחוז מקרים עם תגובה',
        closed_cases: 'כמות מקרים שנסגרו',
        percentage_closed_cases: 'אחוז מקרים שנסגרו',
    },
};
